export default __webpack_public_path__ + "images/3d92ec6c76a4047d692a5f01310c52d6.png";